import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../images/Logo@2x.png";

const Navbar: React.FC = () => {
    const location = useLocation();

    return (
        <>
            <div className="navbarTop"/>
            <nav className="navbar">
                <div className="logo-container">
                    <Link to="/">
                        <img src={logo} alt="Logo" className="logo" />
                    </Link>
                </div>
                <ul className="nav-links">
                    <li><Link to="/create-project" className={location.pathname === "/create-project" || location.pathname === "/" ? "active" : ""}>Create project</Link></li>
                    {/*<li><Link to="/update-project" className={location.pathname === "/update-project" ? "active" : ""}>Update project</Link></li>*/}
                </ul>
            </nav>
        </>
    );
};

export default Navbar;
